import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic IDROTTSKLAR reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-271" data-mp="3fym68hdq8w2r">
      <div className="mx-auto max-w-6xl" data-id="element-272" data-mp="3azje1xiuikc7">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-273" data-mp="3ayhxjdj295n3">
          Vad <em className="text-red-700" data-id="element-274" data-mp="31zw8czj32sdc">lärarna</em> säger
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-275" data-mp="31yl4kzpn1km8">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-276" data-mp="2x2mmftuwkyu9">
              <div className="text-sm text-amber-500" aria-label="5 av 5 stjärnor" data-id="element-277" data-mp="2s39qmjm20hfj">
                <span aria-hidden="true" data-id="element-278" data-mp="v859fwccnb29">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-279" data-mp="q9u0roxsj6lm">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-280" data-mp="h818trjkkmm2">
                <span className="font-semibold text-slate-900" data-id="element-281" data-mp="m5b25ia2xif6">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-282" data-mp="78abli3mjtia"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}